<div
  class="loyalty-grid-container px-3 search-holder mt-4"
>
  <ul class="list-inline grid-top-actions mb-3">
    <li class="list-inline-item ">
      <input
      (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
      #search
        type="text"
        placeholder="{{ 'pages.newRetailer.search' | translate }}"
        matInput
        
        class="
          rounded-pill
          px-3
          py-2
          mb-0
          border-0
          bg-light
          w-100
          me-0
          input-search
          ms-3
        "
      />
      <i
        color="primary"
        class="search-icon-holder"
        matSuffix
        mat-icon-button
        aria-label="Search"
      >
        <mat-icon>search</mat-icon>
      </i>
    </li>

    <li class="list-inline-item float-end me-2">
      <button
        mat-stroked-button
        class="bg-theme mx-2"
        [disabled]="!showUpdateRetailer"
        (click)="managePromotion()"
      >
      <!-- [routerLink]="['edit-promotion/',this.rowId]" -->

        {{ "pages.newRetailer.edit" | translate }}
        <i class="mi mi-drive-file-rename-outline"></i>
      </button>
    </li>
    <li class="list-inline-item float-end me-2">
      <button
      
        mat-stroked-button
        class="bg-theme mx-2"
        [routerLink]="'add-videos'"
      >
        Add
        <i class="mi mi-add"></i>
      </button>
    </li>
    <!--<li class="list-inline-item float-end">
      <button
        mat-stroked-button
        class="bg-theme   mx-2"
        (click)="addPromotionConfig()"
      >
        Add <i class="mi mi-add"></i>
      </button>
    </li> -->
  </ul>
</div>

<ag-grid-angular
      style="width: 100%; height: 65vh; max-height: 70vh"
      class="ag-theme-material"
      [rowHeight]="40"
      [enableFilter]="true"
      [enableSorting]="true"
      [enableColResize]="true"
      [rowSelection]="rowSelection"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
    >
</ag-grid-angular>
